/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */

export type PmTaskCategory = typeof PmTaskCategory[keyof typeof PmTaskCategory];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PmTaskCategory = {
  TODO: 'TODO',
  REVIEW: 'REVIEW',
  IN_PROGRESS: 'IN_PROGRESS',
  DONE: 'DONE',
} as const;
